import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { IndexComponent as IndexBanner02Component } from '../../index-banner-02/index/index.component';
import { TranslateService } from '@ngx-translate/core';
import { ServerConfigService } from '../../../../../../share/service/server-config.service';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from '../../../../../generator-env-token';
import { BannerMeta } from '../../../../../template-generator/entity/banner-meta';
import { Section } from '../../../../../template-generator/entity/section';
import { TemplateService } from '../../../../../template-generator/service/template.service';
import { SECTION_DATA } from '../../../../service/section-data';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-index-banner-04',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent extends IndexBanner02Component {
  remoteDefaultData = [
    {
      id: 0,
      title: '記憶中的技藝',
      type: null,
      description: '傳統建築中的藝術與工藝',
      imageFile: {
        id: 0,
        name: '記憶中的技藝1920x538',
        ext: 'webp',
        objectName: '',
        otherInfos: {},
        url: '/assets/images/網站宣傳1920x538.webp'
      },
      link: '',
      dataProvider: '',
      video: '',
    }
  ];

  constructor(
    @Inject(SECTION_DATA) protected section: Section,
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected serverConfigService: ServerConfigService,
    protected templateService: TemplateService,
    protected translate: TranslateService,
  ) {
    super(section, generatorEnv, platformId, serverConfigService, templateService, translate);

    this.toHomePath = `/${translate.currentLang}`;
  }

  refreshRemoteData() {
    this.serverConfigService.getConfig$().pipe(
      map(siteInfo => {
        return siteInfo.banners;
      })
    ).subscribe(
      (bannerMeta: BannerMeta[]) => {
        this.remoteData = bannerMeta.filter(banner => banner.type === 0 && banner.imageFile);
      },
      (error) => this.remoteData = this.remoteDefaultData
    );
  }
}
